import { api } from "../../utils/api";

export async function postMapImage(id, type, file) {
  const data = {
    type: type,
    enterprise_id: id,
    file: file,
  };
  try {
    const response = await api.post(`upload-map`, data);
    return response.data;
  } catch (error) {
    return error;
  }
}
